import Organisationsnummer from 'organisationsnummer'
import type { DefaultValues } from 'react-hook-form'
import * as yup from 'yup'

import { isEuMember } from '../../../../../common/services/utilsService'

export type InvoicePaymentDetails = {
    email: string
    companyName: string
    address: {
        line1: string
        line2?: string | null
        postalCode: string
        city: string
        country: string
        state?: string | null
    }
    vatNumber?: string
    organizationNumber?: string
    yourReference: string
    discountCode?: string | null
}

export const INVOICE_DETAILS_DEFAULT_VALUES: DefaultValues<InvoicePaymentDetails> = {
    address: { country: 'SE' },
}

export const createInvoiceDetailsSchema = (text: (id: string) => string) =>
    yup.object().shape({
        email: yup.string().required(text('lblEmailRequired')).email(text('lblEmailFormatValidation')),
        companyName: yup.string().required(text('lblOrganisationNameRequired')),
        address: yup
            .object()
            .shape({
                line1: yup.string().required(text('lblAddressLineOneRequired')),
                postalCode: yup.string().required(text('lblPostalCodeRequired')),
                city: yup.string().required(text('lblCityRequired')),
                country: yup.string().required(text('lblCountryRequired')),
            })
            .default(undefined),
        vatNumber: yup.string().when('address.country', {
            is: (countryCode: string) => isEuMember(countryCode) && countryCode !== 'SE',
            then: (value) => value.required(text('lblVatNumberRequired')),
            otherwise: (value) => value.strip(true).notRequired(),
        }),
        organizationNumber: yup.string().when('address.country', {
            is: (countryCode: string) => countryCode === 'SE',
            then: (value) =>
                value
                    .required(text('lblCompanyRegistrationNumberRequired'))
                    .test(
                        'organization-number-valid',
                        text('lblCompanyRegistrationNumberInvalid'),
                        (organizationNumber) =>
                            organizationNumber ? Organisationsnummer.valid(organizationNumber) : false
                    ),
            otherwise: (value) => value.strip(true).notRequired(),
        }),
    })
